import { obtenerNumeroParking } from "@utils/parkingFunctions";

interface PopUpProps {
    description: string;
    direccion?:string;
    plazasTotales?: string;
    plazasLibres?: string;
    nivel?: number,
    forzadura?: number
  }

export default function PopUpAparcamiento(props: PopUpProps ) {
    return (
        <div className="popup-aparcamiento" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <h3 style={{marginTop: '8px', marginBottom: '5px', textAlign: 'center'}}>{props.description}</h3>
            {props.direccion && <p style={{marginTop: '3px', marginBottom: '3px', textAlign: 'center'}}>{props.direccion}</p>}
            {props.plazasTotales && <p style={{marginTop: '3px', marginBottom: '3px'}}>Plazas Totales: {props.plazasTotales}</p>}
            {props.plazasLibres && <p style={{marginTop: '3px', marginBottom: '3px'}}>Plazas Libres: <span style={{color: obtenerNumeroParking( props.plazasLibres, props.nivel, props.forzadura ).color, fontWeight: 'bold'}}>{obtenerNumeroParking( props.plazasLibres, props.nivel, props.forzadura ).libres}</span></p>}
        </div>
    );
}